var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWomen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: 0,
    y: 0,
    width: 38.059,
    height: 38.081,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    "data-name": "Mask Group 5",
    transform: "translate(-324 -183)",
    clipPath: "url(#clipPath)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "woman",
    d: "M16.6,15.041l-3.19-.8-.184-.737a10.561,10.561,0,0,0,3.383-1.059.416.416,0,0,0,.2-.333.423.423,0,0,0-.159-.357c-.015-.01-1.5-1.239-1.5-5.5,0-3.591-.844-5.412-2.5-5.412H12.4A2.664,2.664,0,0,0,10.155.016c-1.564,0-5,1.573-5,6.244,0,4.258-1.488,5.487-1.5,5.5a.416.416,0,0,0,.035.69,10.36,10.36,0,0,0,3.386,1.062l-.184.735-3.189.8A4.672,4.672,0,0,0,.164,19.583.416.416,0,0,0,.581,20h19.15a.416.416,0,0,0,.416-.416A4.673,4.673,0,0,0,16.6,15.041Z",
    transform: "translate(323.844 183.001)",
    fill: "#5d5d5d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomen);
export default __webpack_public_path__ + "static/media/women.89e857f9c4154f09212e3231629910f4.svg";
export { ForwardRef as ReactComponent };